<template>
  <div class="live-page">
    <div class="course-list scrollbar">
      <a-timeline>
        <a-timeline-item v-for="item in courseList" :key="item.id">
          <div class="course-item">
            <div class="course-item-title">{{ item.title }}</div>
            <div class="course-item-attr">
              <div class="attr-item">
                <div class="name">直播日期：</div>
                <div class="value">{{ item.learn_date }}</div>
              </div>
              <div class="attr-item">
                <div class="name">直播时间：</div>
                <div class="value">
                  {{ item.start_time.replace(/\d{4}-\d{2}-\d{2} /i, "") }} ~
                  {{ item.end_time.replace(/\d{4}-\d{2}-\d{2} /i, "") }}
                </div>
              </div>
              <div class="attr-item">
                <div class="name">直播老师：</div>
                <div class="value">
                  {{ item.teacher || details.teacher }}
                </div>
              </div>
       
              <div class="item-action">

                <a-space>
                <a-button v-for="(vd,vdi) in item.video" :key="vd.id"
                  size="small"
                  type="primary"
                  @click="setPlayBack(item,vd.id)"
                >
                  第{{vdi+1}}节
                </a-button>  


                <a-button
                  size="small"
                  type="primary"
                  @click="setLive(item)"
                  v-if="1 === item.status"
                >
                  观看直播
                </a-button>
                </a-space>
              </div>
            </div>
          </div>
        </a-timeline-item>
      </a-timeline>
    </div>
    <div class="player-panel">
      <div :id="player" class="dplayer"></div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.live-page {
  display: flex;
  height: 100%;
}
.course-list {
  width: 35%;
  padding: 6px 12px;
  height: calc(100vh - 260px);
  overflow-y: auto;
  flex-shrink: 0;
}
.player-panel {
  padding-left: 24px;
  flex: 1;
}
.course-item {
  .course-item-title {
    color: #333;
    font-size: 16px;
    font-weight: 700;
  }
  .course-item-attr {
    background: #f5f5f5;
    border-radius: 5px;
    margin-top: 8px;
    padding: 8px;
    .attr-item {
      padding: 4px 0;
      display: flex;
      .name {
        flex-shrink: 0;
        font-weight: 700;
      }
      .value {
        flex: 1;
      }
    }
    .item-action {
      padding-top: 4px;
    }
  }
}
.dplayer {
  width: 100%;
  height: 400px;
}
</style>
<script>
import Hls from "hls.js";
import flvjs from "flv.js";
import DPlayer from "dplayer";

export default {
  props: {
    planId: {
      type: Number,
      default: 0,
    },
    pwid: {
      type: Number,
      default: 0,
    },
    workId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      details: null,
      courseList: [],
      dp: null, //播放器
      timer: null, //定时器
      progress: 0, //播放进度
      courseId: 0, //课次ID
      screenshotUrl: "", //截图地址
      videoId:0,
      payType: 0, //1 直播；2：回放
      player: "play_" + new Date().getTime(),
    };
  },
  watch: {
    progress(now, old) {
      if (now > 0) {
        this.learnReport(old, now);
      }
    },
    pwid() {
      this.getDetails();
      this.initDplayer();
    },
  },
  created() {
    this.getDetails();
  },
  mounted() {
    this.initDplayer();
  },
  filters: {
    formatTime(second) {
      let h = Math.floor(second / 3600);

      let m = Math.floor((second - 3600 * h) / 60);

      let s = second - h * 3600 - 60 * m;

      return (h > 0 ? `${h}时` : "") + (m > 0 ? `${m}分` : "") + `${s}秒`;
    },
  },
  methods: {
    //获取课程列表
    getDetails() {
      this.$request.common.plan
        .details({
          id: this.planId,
          pwid: this.pwid,
        })
        .then(({ data }) => {
          if (0 === data.errcode) {
            this.details = data.data;
            this.courseList = data.data.course;
          }
        });
    },
    initDplayer() {
      console.log("init dplayer");
      this.dp = new DPlayer({
        container: document.getElementById(this.player),
        video: {
          url: "",
          pic: "http://szn.sznykt.com/static/img/player.jpg",
        },
      });
    },

    //观看回放
    setPlayBack(item,vid) {
      this.payType = 2;
      this.courseId = item.id;
      this.progress = 0;

      if (null !== this.dp) {
        this.dp.destroy();
      }

      let videoData = item.video.find(it=>{
          return it.id === vid
      })


      let ext = videoData.url.split(".").pop().toLowerCase();

      let video = {
        url: videoData.url,
      };
      if (ext === "m3u8") {
        video.type = "customHls";
        video.customType = {
          customHls: function (video) {
            const hls = new Hls();
            hls.loadSource(video.src);
            hls.attachMedia(video);
          },
        };
      }
      this.videoId = vid
      this.dp = new DPlayer({
        container: document.getElementById(this.player),
        autoplay: true,
        hotkey: false,
        playbackSpeed: [1], //不能倍数播放
        screenshot: true, //截图
        video: video
        // video: {
        //   url: item.playbackurl,
        //   type: "customHls",
        //   customType: {
        //     customHls: function (video) {
        //       const hls = new Hls();
        //       hls.loadSource(video.src);
        //       hls.attachMedia(video);
        //     },
        //   },
        // },
      });

      if (item.progress > 0) {
        this.dp.seek(item.progress / 1000);
      }

      this.bindAction();
    },
    setLive(item) {
      this.payType = 1;
      this.courseId = item.id;
      this.progress = 0;

      if (null !== this.dp) {
        this.dp.destroy();
      }

      this.dp = new DPlayer({
        container: document.getElementById(this.player),
        live: true,
        autoplay: true,
        hotkey: false,
        video: {
          url: item.playurl,
          pic: "http://szn.sznykt.com/static/img/player.jpg",
          type: "customFlv",
          customType: {
            customFlv: function (video) {
              const flvPlayer = flvjs.createPlayer({
                type: "flv",
                url: video.src,
              });
              flvPlayer.attachMediaElement(video);
              flvPlayer.load();
            },
          },
        },
      });

      this.bindAction();
    },

    bindAction() {
      this.dp.on("play", function () {
        console.log("play action");
      });
      this.dp.on("pause", () => {
        this.endTimer();
      });
      this.dp.on("playing", () => {
        //开始播放
        setTimeout(this.screenshot(), 3000);
        this.startTimer();
      });

      this.dp.on("ended", () => {
        this.endTimer();
      });
      this.dp.on("waiting", () => {
        this.endTimer();
      });

      this.dp.on("screenshot", (t) => {
        console.log("screenshot", t);
      });
    },

    //初始化定时器
    startTimer() {
      this.timer = setInterval(() => {
        this.progress += 10000;
      }, 10000);
    },
    //停止定时器
    endTimer() {
      if (null !== this.timer) {
        clearInterval(this.timer);
      }
    },
    //学时上报
    learnReport(stime, etime) {
      console.log("learnReport:::", stime, etime);

      let time = new Date().getTime();
      let params = {
        pwid: this.pwid,
        workid: this.workId,
        currentTime: time,
        id: time,
        planid: this.planId,
        progress: Math.floor(this.dp.video.currentTime * 1000),
        sectionid: this.courseId,
        thumb: this.screenshotUrl,
        type: this.payType,
        userid: this.$store.get("userid"),
        times: [{ stime: stime, etime: etime }],
        playBackId:this.videoId
      };

      this.$request.common.learn.live(params).then(({ data }) => {
        console.log(data);
      });
    },
    screenshot() {
      let a = document.createElement("canvas");
      let e = this.dp;
      a.width = e.video.videoWidth;
      a.height = e.video.videoHeight;
      a.getContext("2d").drawImage(e.video, 0, 0, a.width, a.height);

      let base64Data = a.toDataURL("image/jpeg");

      this.$request.common.base
        .uploads64({ data: base64Data })
        .then(({ data }) => {
          if (0 === data.errcode) {
            this.screenshotUrl = data.data.link;
          } else {
            this.screenshotUrl = "";
          }
        });
    },
  },
};
</script>